import React from 'react';
import { Route, Routes } from 'react-router-dom';

import './App.css';

import Home from './pages/Home';
import Publications from './pages/Publications';
import People from './pages/People';
import PeopleProfile from './pages/PeopleProfile';
import Gallery from './pages/Gallery';
import ToolsData from './pages/ToolsData';

import Page404 from './pages/404';

import NameHeading from './components/name-header';
import Footer from './components/footer';

const App = () => {
    return (
        <div className="App">
            <NameHeading />

            <Routes>
                <Route path={`${process.env.PUBLIC_URL}/`} element={<Home />} />
                <Route path={`${process.env.PUBLIC_URL}/people`} element={<People />} />
                <Route path={`${process.env.PUBLIC_URL}/publications`} element={<Publications />} />
                <Route
                    path={`${process.env.PUBLIC_URL}/people-profile/:username`}
                    element={<PeopleProfile />}
                />
                <Route path={`${process.env.PUBLIC_URL}/gallery`} element={<Gallery />} />
                <Route path={`${process.env.PUBLIC_URL}/tools-data`} element={<ToolsData />} />
                <Route path="*" element={<Page404 />} />
            </Routes>
            <h1>&nbsp;</h1>
            <Footer />
        </div>
    );
};

export default App;
